import type {GetExamsBooked} from 'domain/usecases/private/booked-flow/exams/get-exams-booked';
import {RemoteGetExamsBooked} from 'data/usecases/private/booked-flow/exams/remote-get-exam-booked';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookedFlowEndPoints} from 'main/factories/usecases/endpoints';
import {getFeatureFlagValue} from 'infra/http/utils/get-feature-flag-value';
import {FeaturesEnum} from 'presentation/constants';

export const makeGetExamsBooked = (): GetExamsBooked => {
	const isExamsSchedulesV3Enabled = getFeatureFlagValue(
		FeaturesEnum.PORTAL_FEATURE_EXAMS_SCHEDULES_V3,
	);

	const endpoint = isExamsSchedulesV3Enabled
		? BookedFlowEndPoints.examsBookedV3
		: BookedFlowEndPoints.examsBooked;

	return new RemoteGetExamsBooked(makeBFFApiUrl(endpoint), makeAuthorizeHttpClientDecorator());
};
